module.exports = __webpack_public_path__ + "img/HIDE_OPTIONS.3c064464.svg";